import { render, staticRenderFns } from "./ghost.vue?vue&type=template&id=cf5514b4&"
import script from "./ghost.vue?vue&type=script&lang=js&"
export * from "./ghost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ghost.vue"
export default component.exports